
import i18n from "i18next";
import { truncate } from "lodash";
import { styled } from "@mui/material/styles";
import ShareIcon from "@mui/icons-material/Share";
import React, { useContext, useMemo } from "react";
import { InvestmentTileContext } from "../context";
import Tooltip from "frontend/src/components/Tooltip/Tooltip";

const TileHeaderContent = styled('div')({
  display: 'flex',
  height: '3rem',
  justifyContent: 'space-between',
});

export function InvestmentTileHeading() {
  const {
    investment: { name, id, isInActive, sharingOrganizationName, sharingOrganizationIconUrl },
    isHovered,
    isSelected,
    toggleInvestment,
    InvestmentControlsAreAvailable,
  } = useContext(InvestmentTileContext);

  const truncatedFundName = useMemo(
    () =>
      truncate(name ?? "", {
        length: 55,
        separator: " ",
      }),
    [name]
  );

  return (
    <div className="tile-header">
      <TileHeaderContent>
        <h4 className="tile-heading fund-name flex-grow">
          {name.length > 50 && (
            <Tooltip placement="bottom" title={name} trigger="hover">
              {truncatedFundName}
            </Tooltip>
          )}

          {name.length <= 50 && `${truncatedFundName}`}
        </h4>
        <div className="ml-auto">
          {sharingOrganizationName && !isHovered && (
            <Tooltip title={i18n.t("fund_tile.shared_by", { org: sharingOrganizationName })} placement="bottom">
              <div className="fund-tile__header-sharing-icon">
                {sharingOrganizationIconUrl ? (
                  <img
                    src={sharingOrganizationIconUrl}
                    alt={sharingOrganizationName}
                    style={{ width: 20, height: 20, objectFit: "contain" }}
                  />
                ) : (
                  <ShareIcon sx={{ fontSize: 16, color: "#666" }} />
                )}
              </div>
            </Tooltip>
          )}
          {isInActive && !isHovered && (
            <div className="fund-tile__header-inactive-flag">
              {i18n.t("fund_tile.inactive")}
            </div>
          )}
          {InvestmentControlsAreAvailable && (
            <div className="fund-select" onClick={toggleInvestment}>
              <input
                id={`fund-tile-select-${id}`}
                type="checkbox"
                className="fund-tile-select"
                name="fund-tile-select"
                checked={isSelected(id)}
                readOnly
              />
              <label htmlFor={`fund-tile-select-${id}`} />
            </div>
          )}
        </div>
      </TileHeaderContent>
    </div>
  );
}
